<template>
	<div class="template-wrapper">
		<h2 class="page-title">{{ $t('storelist') }}</h2>
		<el-divider></el-divider>
		<!--<el-button @click="addstore" v-if="store_management === '1'">{{ $t('addStore') }}</el-button>-->
		<!--        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane :label="item.label" :name="item.id" v-for="item in tab" :key="item.id"></el-tab-pane>
        </el-tabs> -->
		<template v-if="store_management === '1'">
			<el-table :data="tableData.slice((currentPage - 1) * pageSize, currentPage * pageSize)" stripe
				@sort-change="sortChange" style="width: 100%">
				<el-table-column prop="storeid" :label="$t('storeid')" sortable="custom" width="120">
				</el-table-column>
				<el-table-column prop="name" :label="$t('listName')" sortable="custom">
				</el-table-column>
				<el-table-column prop="businesswhatsapp" label="Business WhatsApp" sortable="custom" width="200">
				</el-table-column>
				<el-table-column prop="adminwhatsapp" :label="$t('adminWhatsApp')" sortable="custom" width="200">
				</el-table-column>
				<el-table-column prop="adminemail" :label="$t('adminEmail')" sortable="custom" width="200">
				</el-table-column>
				<el-table-column prop="operation" :label="$t('adminset')" align="center">
					<template slot-scope="scope">
						<div class="operationVid">
							<el-button @click="edititem(scope.row)">{{ $t('edit') }}</el-button>
                            <el-button @click="editstoreauthorize(scope.row.id, scope.row.storeid, scope.row.name)">{{ $t('storeauthorize') }}</el-button>
                            <el-button @click="editstorepos(scope.row.id, scope.row.storeid, scope.row.name)">{{ $t('storepos') }}</el-button>
							<!--<el-button @click="delitem(scope.row.id)">{{ $t('delete') }}</el-button>-->
						</div>
					</template>
				</el-table-column>

			</el-table>
			<div class="pagination flex-center">
				<span class="el-pagination__total">{{ $t('total') }} {{ tableData.length }} {{ $t('items') }}</span>
				<el-pagination background @current-change="handleCurrentChange" :current-page="currentPage"
					:page-size="pageSize" layout="prev,pager,next" :total="tableData.length"></el-pagination>
			</div>
		</template>
		<template v-if="store_management === '0'">
            <span>{{ $t("NoPermissions") }}</span>
        </template>

		<!-- add -->
		<el-dialog :title="$t('addStore')" :visible.sync="dialogVisible" :width="$store.state.isMobile ? '90%' : '556px'"
			:before-close="handleClose">
			<div class="add-template">
				<el-form ref="form" :model="form">
					<el-form-item :label="$t('storeid')">
						<el-input v-model="form.storeid" :rows="1"></el-input>
					</el-form-item>
					<el-form-item :label="$t('storeName')">
						<el-input v-model="form.name" rows="1"></el-input>
					</el-form-item>
					<el-form-item label="Business WhatsApp">
						<el-input v-model="form.businesswhatsapp" :rows="1"></el-input>
					</el-form-item>
					<el-form-item :label="$t('adminWhatsApp')">
						<el-input v-model="form.adminwhatsapp" :rows="1"></el-input>
					</el-form-item>
					<el-form-item :label="$t('adminEmail')">
						<el-input v-model="form.adminemail" :rows="1"></el-input>
					</el-form-item>
                    <el-form-item :label="$t('testerWhatsApp')">
						<el-input v-model="form.testerwhatsapp" :rows="1"></el-input>
					</el-form-item>
                    <el-form-item :label="$t('isShipping')">
                        <el-select v-model="form.isShippingFlow" placeholder="">
							<el-option :label="$t('yes')" value="1"></el-option>
							<el-option :label="$t('no')" value="0"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('shippingflowid')">
                        <a href="shippingflow.txt" target="_blank">{{ $t("downloadShippingFlow") }}</a>
						<el-input v-model="form.shippingflow_id" :rows="1"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">{{ $t("Cancel") }}</el-button>
				<el-button type="primary" @click="sure">{{
					$t("Sure")
				}}</el-button>
			</span>
		</el-dialog>

		<!-- edit -->
		<el-dialog :title="$t('editStore')" :visible.sync="dialogEditFormVisible"
			:width="$store.state.isMobile ? '90%' : '556px'" :before-close="handleClose">
			<div class="add-template">
                <el-form ref="editform" :model="editform">
                    <el-tabs v-model="editStoreVisibleTab" class="demo-tabs" name="0">
                        <el-tab-pane :label="$t('storeInfo')">
                            <el-form-item :label="$t('storeid')">
                                <el-input v-model="editform.storeid" readonly="true" :rows="1"></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('storeName')">
                                <el-input v-model="editform.name" readonly="true" rows="1"></el-input>
                            </el-form-item>
                            <el-form-item label="Business WhatsApp">
                                <el-input v-model="editform.businesswhatsapp" readonly="true" :rows="1"></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('adminWhatsApp')">
                                <el-input v-model="editform.adminwhatsapp" :rows="1"></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('adminEmail')">
                                <el-input v-model="editform.adminemail" :rows="1"></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('testerWhatsApp')">
                                <el-input v-model="editform.testerwhatsapp" :rows="1"></el-input>
                            </el-form-item>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('storeShippingInfo')">
                            <el-form-item :label="$t('isShipping')">
                                <el-select v-model="editform.isShippingFlow" placeholder="">
                                    <el-option :label="$t('yes')" value="1"></el-option>
                                    <el-option :label="$t('no')" value="0"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item :label="$t('isShippingPickup')">
                                <el-select v-model="editform.isShippingPickup" placeholder="">
                                    <el-option :label="$t('yes')" value="1"></el-option>
                                    <el-option :label="$t('no')" value="0"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item :label="$t('setupShippingPickupAddress')">
                                <el-button @click="setuppickupaddress(editform.storeid)">{{ $t('setupShippingPickupAddress') }}</el-button>
                            </el-form-item>
                            <el-form-item :label="$t('isShippingLogistics')">
                                <el-select v-model="editform.isShippingLogistics" placeholder="">
                                    <el-option :label="$t('yes')" value="1"></el-option>
                                    <el-option :label="$t('no')" value="0"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item :label="$t('shippingflowid')">
                                <a href="shippingflow.txt" target="_blank">{{ $t("downloadShippingFlow") }}</a>
                                <el-input v-model="editform.shippingflow_id" :rows="1"></el-input>
                            </el-form-item>
                            
                        </el-tab-pane>
                    </el-tabs>
                </el-form>
				
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogEditFormVisible = false">{{ $t("Cancel") }}</el-button>
				<el-button type="primary" @click="edit">{{
					$t("Sure")
				}}</el-button>
			</span>
		</el-dialog>

        <!-- pickup address -->
        <el-dialog :title="$t('setupShippingPickupAddress')" :visible.sync="dialogPickupAddressVisible"
        :width="$store.state.isMobile ? '90%' : '756px'">
            <!--
            <h3>{{ dialogGroupVisibleTitle }}</h3>
            <br />
            <br />-->
            <div class="add-template">
                <el-form ref="form" :model="pickupaddressform">
                    <template>
                        <el-button @click="addPickupaddress()">{{ $t("pickupaddressAdd") }}</el-button>
                    </template>
                    <el-table :data="pickupaddressList.slice((pickupaddressListCurrentPage - 1) * pickupaddressListPageSize, pickupaddressListCurrentPage * pickupaddressListPageSize)
                        " stripe @sort-change="sortChange_group" style="width: 100%">
                        <el-table-column prop="location" :label="$t('pickuplocation')" sortable="custom" width="180">
                        </el-table-column>
                        <el-table-column prop="time" :label="$t('pickuptime')" sortable="custom" width="180">
                        </el-table-column>
                        <el-table-column prop="operation" :label="$t('adminset')" align="center">
                            <template slot-scope="scope">
                                <div class="operationVid">
                                    <el-button @click="editPickupaddress(scope.row.id)">{{ $t("pickupaddressEdit") }}</el-button>
                                    <el-button @click="deletePickupaddress(scope.row.id, scope.row.storeid)">{{ $t("pickupaddressDelete") }}</el-button>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="pagination flex-center">
                        <span class="el-pagination__total">{{ $t("total") }} {{ pickupaddressList.length }} {{ $t("items") }}</span>
                        <el-pagination background @current-change="handlePickupaddressListCurrentChange"
                        :current-page="pickupaddressListCurrentPage" :page-size="pickupaddressListPageSize" layout="prev,pager,next"
                        :total="pickupaddressList.length"></el-pagination>
                    </div>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogPickupAddressVisible = false">{{ $t("Cancel") }}</el-button>
                <el-button type="primary" @click="closeDialogStorepos()">{{
                $t("Sure")
                }}</el-button>
            </span>
        </el-dialog>

        <!-- pickup address add -->
		<el-dialog :title="$t('pickupaddressAdd')" :visible.sync="dialogAddPickupAddressVisible" :width="$store.state.isMobile ? '90%' : '556px'"
			:before-close="handleCloseDialogAddPickupAddressVisible">
			<div class="add-template">
				<el-form ref="form" :model="pickupAddressform">
					<el-form-item :label="$t('pickuplocation')">
						<el-input v-model="pickupAddressform.location" :rows="1"></el-input>
					</el-form-item>
                    <el-form-item :label="$t('pickuptime')">
						<el-input v-model="pickupAddressform.time" :rows="1"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogAddPickupAddressVisible = false">{{ $t("Cancel") }}</el-button>
				<el-button type="primary" @click="confirmAddPickupaddress()">{{
					$t("Sure")
				}}</el-button>
			</span>
		</el-dialog>

        <!-- pickup address edit -->
		<el-dialog :title="$t('pickupaddressEdit')" :visible.sync="dialogEditPickupAddressVisible" :width="$store.state.isMobile ? '90%' : '556px'"
			:before-close="handleCloseDialogEditPickupAddressVisible">
			<div class="add-template">
				<el-form ref="form" :model="pickupAddressform">
					<el-form-item :label="$t('pickuplocation')">
						<el-input v-model="pickupAddressform.location" :rows="1"></el-input>
					</el-form-item>
                    <el-form-item :label="$t('pickuptime')">
						<el-input v-model="pickupAddressform.time" :rows="1"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogEditPickupAddressVisible = false">{{ $t("Cancel") }}</el-button>
				<el-button type="primary" @click="confirmEditPickupaddress()">{{
					$t("Sure")
				}}</el-button>
			</span>
		</el-dialog>

        <!-- storeauthorize -->
        <el-dialog :title="$t('storeauthorize')" :visible.sync="dialogStoreauthorizeVisible"
        :width="$store.state.isMobile ? '90%' : '756px'" :before-close="handleClose">
            <!--
            <h3>{{ dialogGroupVisibleTitle }}</h3>
            <br />
            <br />-->
            <div class="add-template">
                <el-form ref="form" :model="storeauthorizeform">
                    <template>
                        <el-button @click="addAuthorizemember()">{{ $t("storeauthorizeAdd") }}</el-button>
                    </template>
                    <el-table :data="storeauthorizeList.slice((storeauthorizeListCurrentPage - 1) * storeauthorizeListPageSize, storeauthorizeListCurrentPage * storeauthorizeListPageSize)
                        " stripe @sort-change="sortChange_group" style="width: 100%">
                        <el-table-column prop="login_user" :label="$t('storeauthorizeLoginname')" sortable="custom" width="180">
                        </el-table-column>
                        <el-table-column prop="name" :label="$t('storeauthorizeName')" sortable="custom">
                        </el-table-column>
                        <el-table-column prop="operation" :label="$t('adminset')" align="center">
                            <template slot-scope="scope">
                                <div class="operationVid">
                                    <el-button @click="editAuthorizemember(scope.row.id)">{{ $t("storeauthorizeEdit") }}</el-button>
                                    <el-button @click="deleteAuthorizemember(scope.row.id)">{{ $t("storeauthorizeDelete") }}</el-button>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="pagination flex-center">
                        <span class="el-pagination__total">{{ $t("total") }} {{ storeauthorizeList.length }} {{ $t("items") }}</span>
                        <el-pagination background @current-change="handleStoreauthorizeListCurrentChange"
                        :current-page="storeauthorizeListCurrentPage" :page-size="storeauthorizeListPageSize" layout="prev,pager,next"
                        :total="storeauthorizeList.length"></el-pagination>
                    </div>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogStoreauthorizeVisible = false">{{ $t("Cancel") }}</el-button>
                <el-button type="primary" @click="dialogStoreauthorizeVisible = false">{{
                $t("Sure")
                }}</el-button>
            </span>
        </el-dialog>

        <!-- storeauthorize add -->
		<el-dialog :title="$t('storeauthorizeAdd')" :visible.sync="dialogAddStoreauthorizeVisible" :width="$store.state.isMobile ? '90%' : '556px'"
			:before-close="handleCloseDialogAddStoreauthorizeVisible">
			<div class="add-template">
				<el-form ref="form" :model="storeauthorizeform">
                    <el-tabs v-model="addStoreauthorizeVisibleTab" class="demo-tabs">
                        <el-tab-pane :label="$t('storeauthorizeTabinfo')" name="0">
                            <el-form-item :label="$t('storeauthorizeName')">
                                <el-input v-model="storeauthorizeform.name" :rows="1"></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('storeauthorizeLoginname')">
                                <el-input v-model="storeauthorizeform.loginname" rows="1"></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('storeauthorizeLoginpassword')">
                                <el-input v-model="storeauthorizeform.password" type="password" show-password></el-input>
                            </el-form-item>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('storeauthorizeTabPermissions')" name="1">
                            <el-table :data="storeauthorizePermissionsData1" stripe style="width: 100%">
                                <el-table-column prop="name" label="">
                                </el-table-column>
                                <el-table-column :label="$t('storeauthorizeTabPermissionsEnable')">
                                    <template slot-scope="scope">
                                        <el-switch v-model="scope.row.status" />
                                    </template>
                                </el-table-column>
                            </el-table>
                            <br />
                            <el-table :data="storeauthorizePermissionsData2" stripe style="width: 100%">
                                <el-table-column prop="name" label="">
                                </el-table-column>
                                <el-table-column :label="$t('storeauthorizeTabPermissionsRead')">
                                    <template slot-scope="scope">
                                        <el-switch v-model="scope.row.read_status" />
                                    </template>
                                </el-table-column>
                                <el-table-column :label="$t('storeauthorizeTabPermissionsEdit')">
                                    <template slot-scope="scope">
                                        <el-switch v-model="scope.row.edit_status" />
                                    </template>
                                </el-table-column>
                            </el-table>
                            <br />
                            <el-table :data="storeauthorizePermissionsData3" stripe style="width: 100%">
                                <el-table-column prop="name" label="">
                                </el-table-column>
                                <el-table-column :label="$t('storeauthorizeTabPermissionsEnable')">
                                    <template slot-scope="scope">
                                        <el-switch v-model="scope.row.status" />
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-tab-pane>
                    </el-tabs>
					
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogAddStoreauthorizeVisible = false">{{ $t("Cancel") }}</el-button>
				<el-button type="primary" @click="addStoreauthorize">{{
					$t("Sure")
				}}</el-button>
			</span>
		</el-dialog>

        <!-- storeauthorize edit -->
		<el-dialog :title="$t('storeauthorizeEdit')" :visible.sync="dialogEditStoreauthorizeVisible" :width="$store.state.isMobile ? '90%' : '556px'"
			:before-close="handleCloseDialogEditStoreauthorizeVisible">
			<div class="add-template">
				<el-form ref="form" :model="storeauthorizeform">
                    <el-tabs v-model="editStoreauthorizeVisibleTab" class="demo-tabs" name="0">
                        <el-tab-pane :label="$t('storeauthorizeTabinfo')">
                            <el-form-item :label="$t('storeauthorizeName')">
                                <el-input v-model="storeauthorizeform.name" :rows="1"></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('storeauthorizeLoginname')">
                                <el-input v-model="storeauthorizeform.loginname" rows="1"></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('storeauthorizeLoginpassword')">
                                <el-input v-model="storeauthorizeform.password" type="password" show-password></el-input>
                            </el-form-item>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('storeauthorizeTabPermissions')" name="1">
                            <el-table :data="storeauthorizePermissionsData1" stripe style="width: 100%">
                                <el-table-column prop="name" label="">
                                </el-table-column>
                                <el-table-column :label="$t('storeauthorizeTabPermissionsEnable')">
                                    <template slot-scope="scope">
                                        <el-switch v-model="scope.row.status" :active-value="true" :inactive-value="false" />
                                    </template>
                                </el-table-column>
                            </el-table>
                            <br />
                            <el-table :data="storeauthorizePermissionsData2" stripe style="width: 100%">
                                <el-table-column prop="name" label="">
                                </el-table-column>
                                <el-table-column :label="$t('storeauthorizeTabPermissionsRead')">
                                    <template slot-scope="scope">
                                        <el-switch v-model="scope.row.read_status" :active-value="true" :inactive-value="false" />
                                    </template>
                                </el-table-column>
                                <el-table-column :label="$t('storeauthorizeTabPermissionsEdit')">
                                    <template slot-scope="scope">
                                        <el-switch v-model="scope.row.edit_status" :active-value="true" :inactive-value="false" />
                                    </template>
                                </el-table-column>
                            </el-table>
                            <br />
                            <el-table :data="storeauthorizePermissionsData3" stripe style="width: 100%">
                                <el-table-column prop="name" label="">
                                </el-table-column>
                                <el-table-column :label="$t('storeauthorizeTabPermissionsEnable')">
                                    <template slot-scope="scope">
                                        <el-switch v-model="scope.row.status" :active-value="true" :inactive-value="false" />
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-tab-pane>
                    </el-tabs>
					
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogEditStoreauthorizeVisible = false">{{ $t("Cancel") }}</el-button>
				<el-button type="primary" @click="confirmeditStoreauthorize">{{
					$t("Sure")
				}}</el-button>
			</span>
		</el-dialog>

        <!-- storepos -->
        <el-dialog :title="$t('storepos')" :visible.sync="dialogStoreposVisible"
        :width="$store.state.isMobile ? '90%' : '756px'" :before-close="handleClose">
            <!--
            <h3>{{ dialogGroupVisibleTitle }}</h3>
            <br />
            <br />-->
            <div class="add-template">
                <el-form ref="form" :model="storeposform">
                    <el-tabs v-model="storePOSVisibleTab" class="demo-tabs" @tab-click="handleStoreposTabClick">
                        <el-tab-pane :label="$t('storeposTabPayment')" name="0">
                            <template>
                                <el-button @click="addStorepos()">{{ $t("storeposAdd") }}</el-button>
                            </template>
                            <el-table :data="storeposList.slice((storeposListCurrentPage - 1) * storeposListPageSize, storeposListCurrentPage * storeposListPageSize)
                                " stripe @sort-change="sortChange_group" style="width: 100%">
                                <el-table-column prop="name" :label="$t('storeposName')" sortable="custom" width="180">
                                </el-table-column>
                                <el-table-column prop="isDefault" :label="$t('storeposDefault')" sortable="custom" width="180">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.isDefault === '0'">{{ $t('no') }}</span>
                                        <span v-if="scope.row.isDefault === '1'">{{ $t('yes') }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="operation" :label="$t('adminset')" align="center">
                                    <template slot-scope="scope">
                                        <div class="operationVid">
                                            <el-button @click="editStorepos(scope.row.id)">{{ $t("storeposEdit") }}</el-button>
                                            <el-button @click="deleteStorepos(scope.row.id, scope.row.storeid)">{{ $t("storeposDelete") }}</el-button>
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div class="pagination flex-center">
                                <span class="el-pagination__total">{{ $t("total") }} {{ storeposList.length }} {{ $t("items") }}</span>
                                <el-pagination background @current-change="handleStoreposListCurrentChange"
                                :current-page="storeposListCurrentPage" :page-size="storeposListPageSize" layout="prev,pager,next"
                                :total="storeposList.length"></el-pagination>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('storeposTabIP')" name="1">
                            <p>{{ $t("storeposIPEnable") }}</p>
                            <el-switch v-model="ipenable" :active-value="true" :inactive-value="false" />
                            <br><br>
                            <template>
                                <el-button @click="addStoreposipwhitelist()">{{ $t("storeposAddIP") }}</el-button>
                            </template>
                            <el-table :data="storeposipList.slice((storeposipListCurrentPage - 1) * storeposipListPageSize, storeposipListCurrentPage * storeposipListPageSize)
                                " stripe @sort-change="sortChange_group" style="width: 100%">
                                <el-table-column prop="ip" label="IP" sortable="custom" width="180">
                                </el-table-column>
                                <el-table-column prop="operation" :label="$t('adminset')" align="center">
                                    <template slot-scope="scope">
                                        <div class="operationVid">
                                            <el-button @click="editStoreposip(scope.row.id)">{{ $t("storeposEdit") }}</el-button>
                                            <el-button @click="deleteStoreposip(scope.row.id, scope.row.storeid)">{{ $t("storeposDelete") }}</el-button>
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div class="pagination flex-center">
                                <span class="el-pagination__total">{{ $t("total") }} {{ storeposipList.length }} {{ $t("items") }}</span>
                                <el-pagination background @current-change="handleStoreposipListCurrentChange"
                                :current-page="storeposipListCurrentPage" :page-size="storeposipListPageSize" layout="prev,pager,next"
                                :total="storeposipList.length"></el-pagination>
                            </div>



                        </el-tab-pane>
                        <el-tab-pane :label="$t('storeposRedund')" name="2">
                            <p>{{ $t("fpspay") }}</p>
                            <template>
                                <el-button @click="setupStoreposRefundPWFPS()">{{ $t("storeposRedundPW") }}</el-button>
                            </template>
                        </el-tab-pane>
                    </el-tabs>

                    
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogStoreposVisible = false">{{ $t("Cancel") }}</el-button>
                <el-button type="primary" @click="closeDialogStorepos()">{{
                $t("Sure")
                }}</el-button>
            </span>
        </el-dialog>

        <!-- storepos add -->
		<el-dialog :title="$t('storeposAdd')" :visible.sync="dialogAddStoreposVisible" :width="$store.state.isMobile ? '90%' : '556px'"
			:before-close="handleCloseDialogAddStoreposVisible">
			<div class="add-template">
				<el-form ref="form" :model="storeposform">
					<el-form-item :label="$t('storeposName')">
						<el-input v-model="storeposform.name" :rows="1"></el-input>
					</el-form-item>
                    <el-form-item :label="$t('storeposDefault')">
                        <el-select v-model="storeposform.isDefault" placeholder="">
							<el-option :label="$t('yes')" value="1"></el-option>
							<el-option :label="$t('no')" value="0"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogAddStoreposVisible = false">{{ $t("Cancel") }}</el-button>
				<el-button type="primary" @click="confirmAddStorepos">{{
					$t("Sure")
				}}</el-button>
			</span>
		</el-dialog>

        <!-- storepos edit -->
		<el-dialog :title="$t('storeposEdit')" :visible.sync="dialogEditStoreposVisible" :width="$store.state.isMobile ? '90%' : '556px'"
			:before-close="handleCloseDialogEditStoreposVisible">
			<div class="add-template">
				<el-form ref="form" :model="storeposform">
					<el-form-item :label="$t('storeposName')">
						<el-input v-model="storeposform.name" :rows="1"></el-input>
					</el-form-item>
                    <el-form-item :label="$t('storeposDefault')">
                        <el-select v-model="storeposform.isDefault" placeholder="">
							<el-option :label="$t('yes')" value="1"></el-option>
							<el-option :label="$t('no')" value="0"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogEditStoreposVisible = false">{{ $t("Cancel") }}</el-button>
				<el-button type="primary" @click="confirmEditStorepos">{{
					$t("Sure")
				}}</el-button>
			</span>
		</el-dialog>

        <!-- storepos ip add -->
		<el-dialog :title="$t('storeposAddIP')" :visible.sync="dialogAddStoreposipVisible" :width="$store.state.isMobile ? '90%' : '556px'"
			:before-close="handleCloseDialogAddStoreposipVisible">
			<div class="add-template">
				<el-form ref="form" :model="storeposipform">
					<el-form-item label="IP">
						<el-input v-model="storeposipform.ip" :rows="1"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogAddStoreposipVisible = false">{{ $t("Cancel") }}</el-button>
				<el-button type="primary" @click="confirmAddStoreposip">{{
					$t("Sure")
				}}</el-button>
			</span>
		</el-dialog>

        <!-- storepos ip edit -->
		<el-dialog :title="$t('storeposEditIP')" :visible.sync="dialogEditStoreposipVisible" :width="$store.state.isMobile ? '90%' : '556px'"
			:before-close="handleCloseDialogEditStoreposipVisible">
			<div class="add-template">
				<el-form ref="form" :model="storeposipform">
					<el-form-item label="IP">
						<el-input v-model="storeposipform.ip" :rows="1"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogEditStoreposipVisible = false">{{ $t("Cancel") }}</el-button>
				<el-button type="primary" @click="confirmEditStoreposip">{{
					$t("Sure")
				}}</el-button>
			</span>
		</el-dialog>

        <!-- storepos refund pw fps -->
		<el-dialog :title="$t('storeposRedundPWFPS')" :visible.sync="dialogRefundPWFPSVisible" :width="$store.state.isMobile ? '90%' : '556px'"
			:before-close="handleCloseDialogRefundPWFPSVisible">
			<div class="add-template">
				<el-form ref="form" :model="storeposrefundpwfpsform">
					<el-form-item :label="$t('storeposRedundPWoldpw')">
						<el-input v-model="storeposrefundpwfpsform.oldpw" :rows="1" type="password" show-password></el-input>
					</el-form-item>
                    <el-form-item :label="$t('storeposRedundPWnewpw')">
						<el-input v-model="storeposrefundpwfpsform.newpw" :rows="1" type="password" show-password></el-input>
					</el-form-item>
                    <el-form-item :label="$t('storeposRedundPWconfirmnewpw')">
						<el-input v-model="storeposrefundpwfpsform.confirmnewpw" :rows="1" type="password" show-password></el-input>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogRefundPWFPSVisible = false">{{ $t("Cancel") }}</el-button>
				<el-button type="primary" @click="confirmRefundPWFPS">{{
					$t("Sure")
				}}</el-button>
			</span>
		</el-dialog>

        




        

	</div>
</template>
<script>
import {
	formatDate
} from '../../assets/date.js'
import axios from 'axios'
import {
	tongyong,
	funk,
	getStore,
	addStore,
    getStoreauthorizelist,
    addStoreauthorizelist,
    editStoreauthorizelist,
    deleteStoreauthorizelist,
    getinfoStoreauthorizelist,
    addStoreposlist,
    getStoreposlist,
    storeposiplist,
    getPickupaddresslist,
    refundDBS
} from '@/api'
import {
	addAutoTemplate
} from '@/api'
export default {
	data() {
		return {
			store_management: '0',
			exportcsv: '0',
			qyid: '',
            storeid:'',
			dialogImageUrl: '',
			fileList: [],
			disabled: false,
			showViewer: false, // 显示查看器
			ewmdata: [],
			fileList: [],
			pagelist: [],
			huodonglist: [],
			currentPage: 1, // 当前页码
			pageSize: 20, // 每页显示的行数
			activeName: '0',
			dialogVisible: false,
			dialogEditFormVisible: false,
            dialogPickupAddressVisible: false,
            dialogStoreauthorizeVisible:false,
            dialogStoreauthorizeVisibleTitle:'',
            dialogStoreauthorizeVisibleStoreid: '',
            dialogAddStoreauthorizeVisible: false,
			dialogEditStoreauthorizeVisible: false,
            dialogStoreposVisible:false,
            dialogStoreposVisibleTitle:'',
            dialogStoreposVisibleStoreid: '',
            dialogAddStoreposVisible: false,
			dialogEditStoreposVisible: false,
            dialogAddStoreposipVisible: false,
			dialogEditStoreposipVisible: false,
            dialogRefundPWFPSVisible: false,
            dialogAddPickupAddressVisible: false,
			dialogEditPickupAddressVisible: false,
			tab: [{
				label: this.$t('underApproval'),
				id: '0'
			},
			{
				label: this.$t('passed'),
				id: '1'
			}
			],
			tableData: [],
			tableData1: [

				{
					timer: '2018-01-01',
					name: '测试範本001',
					status: '审核中'
				},
			],
			metaTemplateList: [],
			status: 0,
			form: {
				qyid: '',
				storeid: '',
				name: '',
				businesswhatsapp: '',
				adminwhatsapp: '',
				adminemail: '',
                testerwhatsapp: '',
                isshipping: false,
                shippingflowid: ''

			},
			editform: {
				qyid: '',
				storeid: '',
				name: '',
				businesswhatsapp: '',
				adminwhatsapp: '',
				adminemail: '',
                testerwhatsapp: '',
                isshipping: false,
                shippingflowid: ''

			},
            storeauthorizeform: {
                name:'',
                loginname:'',
                password:''
            },
            storeposform: {
                name:'',
                isDefault: '0'
            },
            storeposipform: {
                ip:''
            },
            pickupAddressform: {
                location:'',
                time: ''
            },
            storeposrefundpwfpsform: {
                oldpw: '',
                newpw: '',
                confirmnewpw: ''
            },
            editstoreauthorizeformid: '',
            editstoreposformid: '',
            storeauthorizeList: [],
            storeposList: [],
            pickupaddressList: [],
            storeposipList: [],
            storeauthorizeListCurrentPage: 1, // 当前页码
            storeauthorizeListPageSize: 10, // 每页显示的行数
            storeposListCurrentPage: 1, // 当前页码
            storeposListPageSize: 10, // 每页显示的行数
            pickupaddressListCurrentPage: 1, // 当前页码
            pickupaddressListPageSize: 10, // 每页显示的行数
            storeposipListCurrentPage: 1, // 当前页码
            storeposipListPageSize: 10, // 每页显示的行数
            storeauthorizePermissionsData1: [
                {
                    id: 1,
                    name: this.$t('storeauthorizeTabPermissions_storemanagement'),
                    status: false
                },
                {
                    id: 2,
                    name: this.$t('storeauthorizeTabPermissions_exportcsv'),
                    status: false
                }
            ],
            storeauthorizePermissionsData2: [
                {
                    id: 1,
                    name: this.$t('storeauthorizeTabPermissions_membership'),
                    read_status: false,
                    edit_status: false
                },
                {
                    id: 2,
                    name: this.$t('storeauthorizeTabPermissions_broadcasting'),
                    read_status: false,
                    edit_status: false
                },
                {
                    id: 3,
                    name: this.$t('storeauthorizeTabPermissions_coupon'),
                    read_status: false,
                    edit_status: false
                },
                {
                    id: 4,
                    name: this.$t('storeauthorizeTabPermissions_chatbotsetting'),
                    read_status: false,
                    edit_status: false
                },
                {
                    id: 5,
                    name: this.$t('storeauthorizeTabPermissions_chatbotmessage'),
                    read_status: false,
                    edit_status: false
                },
                {
                    id: 6,
                    name: this.$t('storeauthorizeTabPermissions_productsetting'),
                    read_status: false,
                    edit_status: false
                },
                {
                    id: 7,
                    name: this.$t('storeauthorizeTabPermissions_order'),
                    read_status: false,
                    edit_status: false
                },
                {
                    id: 8,
                    name: this.$t('storeauthorizeTabPermissions_payment'),
                    read_status: false,
                    edit_status: false
                },
            ],
            storeauthorizePermissionsData3: [
                {
                    id: 1,
                    name: this.$t('storeauthorizeTabPermissions_managerapp'),
                    status: false
                },
            ],
            ipenable: false
            //storeauthorizePermissionsData_storemanagement: 0,
        }
	},
	filters: {
		formatDate: function (time) {
			time = time * 1000 //注意：time应为格式为13位unix時間戳，如果是10位的unix時間戳，需要乘以1000
			let date = new Date(time)
			return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
		}
	},

	created() {
		var auser = JSON.parse(window.localStorage.getItem('auserinfo'))
        this.qyid = auser.qyid
        this.storeid = auser.storeid
        this.store_management = auser.store_management
        this.exportcsv = auser.exportcsv
		this.gettemplist()
	},
	methods: {
		addstore() {
			this.dialogVisible = true
			this.form = {}
		},
		edititem(data) {
			this.form = data
			this.dialogVisible = true
		},
		beforeHandleCommand(e) {
			console.log(e);
		},
		// 页面切换方法
		handleCurrentChange(val) {
			this.currentPage = val;
		},
        handleStoreauthorizeListCurrentChange(val) {
			this.storeauthorizeListCurrentPage = val;
		},
        handleStoreposListCurrentChange(val) {
			this.storeposListCurrentPage = val;
		},
		handleClick(tab, event) {
			console.log(tab.index);
			this.status = tab.index
			this.currentPage = 1
			this.gettemplist()
		},
		handleClose() {
			this.dialogVisible = false
			this.dialogEditFormVisible = false;
            this.dialogStoreauthorizeVisible = false;
            this.dialogStoreposVisible = false;
            this.dialogPickupAddressVisible = false;
		},
        handleCloseDialogAddStoreauthorizeVisible() {
            this.dialogAddStoreauthorizeVisible = false;
        },
        handleCloseDialogEditStoreauthorizeVisible() {
            this.dialogEditStoreauthorizeVisible = false;
        },
        handleCloseDialogAddStoreposVisible() {
            this.dialogAddStoreposVisible = false;
        },
        handleCloseDialogEditStoreposVisible() {
            this.dialogEditStoreposVisible = false;
        },
        handleCloseDialogAddPickupAddressVisible() {
            this.dialogAddPickupAddressVisible = false;
        },
        handleCloseDialogEditPickupAddressVisible() {
            this.dialogEditPickupAddressVisible = false;
        },
        handleCloseDialogAddStoreposipVisible() {
            this.dialogAddStoreposipVisible = false;
        },
        handleCloseDialogEditStoreposipVisible() {
            this.dialogEditStoreposipVisible = false;
        },
        handleCloseDialogRefundPWFPSVisible() {
            this.dialogRefundPWFPSVisible = false;
        },
		handlePictureCardPreview() {

		},
		handleRemove() {

		},
        closeDialogStorepos() {
            this.dialogStoreposVisible = false
            let fdata = {
                qyid: this.qyid,
                storeid: this.storeposipform.storeid,
                enableip: this.ipenable,
                action: "editenableip"
            }
            console.log("fdataaaaaaaaaaaaaaaaaaaaaaaaaaaa")
            console.log(fdata)
            storeposiplist(fdata).then(res => {
                if (res.code == 1) {
                    console.log(res.data);
                    //this.storeposipList = res.data;
                    //this.getlist()
                } else {
                    console.log("error")
                    this.$message({
                        type: 'error',
                        message: res.msg
                    })
                }
            })



        },
		// 新增範本点击确定
		sure() {
			var user = JSON.parse(window.localStorage.getItem('userinfo'))
			console.log(user);

			this.form.qyid = user.id
			this.form.action = "add"

			console.log(this.form);

			addStore(this.form).then(res => {
				if (res.code == 1) {
					this.$message({
						type: 'success',
						message: res.msg
					})
					this.dialogVisible = false
					this.gettemplist()
				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})
		},
		edit() {
			var user = JSON.parse(window.localStorage.getItem("userinfo"));
			console.log(user)

			this.editform.qyid = user.id
			this.editform.action = "edit"


			addStore(this.editform).then((res) => {
				if (res.code == 1) {
					this.$message({
						type: "success",
						message: res.msg,
					});
					this.dialogEditFormVisible = false;
					this.gettemplist()
				} else {
					this.$message({
						type: "error",
						message: res.msg,
					});
				}
			});
		},
		edititem(data) {
			this.editform = data
			this.dialogEditFormVisible = true
			console.log("data")
			console.log(data)
		},
        editstoreauthorize(id, storeid, title) {
            this.dialogStoreauthorizeVisible = true;
            this.dialogStoreauthorizeVisibleTitle = title;
            this.dialogStoreauthorizeVisibleStoreid = storeid;
            this.storeauthorizeform.qyid = this.qyid;
            this.storeauthorizeform.storeid = storeid;

            /*
            */

            let fdata = {
                qyid: this.qyid,
                storeid: storeid
            }
            getStoreauthorizelist(fdata).then(res => {
                if (res.code == 1) {
                    console.log(res.data);
                    this.storeauthorizeList = res.data;
                    //this.getlist()
                } else {
                    console.log("error")
                    this.$message({
                        type: 'error',
                        message: res.msg
                    })
                }
            })
            
        },
        confirmeditStoreauthorize() {
            console.log(this.editstoreauthorizeformid)
            this.storeauthorizeform.action = "edit"
            this.storeauthorizeform.id = this.editstoreauthorizeformid
            this.storeauthorizeform.permissions_storemanagement = this.storeauthorizePermissionsData1[0].status
            this.storeauthorizeform.permissions_exportcsv = this.storeauthorizePermissionsData1[1].status
            this.storeauthorizeform.permissions_managerapp_access = this.storeauthorizePermissionsData3[0].status
            this.storeauthorizeform.permissions_membership_read = this.storeauthorizePermissionsData2[0].read_status
            this.storeauthorizeform.permissions_membership_edit = this.storeauthorizePermissionsData2[0].edit_status
            this.storeauthorizeform.permissions_broadcasting_read = this.storeauthorizePermissionsData2[1].read_status
            this.storeauthorizeform.permissions_broadcasting_edit = this.storeauthorizePermissionsData2[1].edit_status
            this.storeauthorizeform.permissions_coupon_read = this.storeauthorizePermissionsData2[2].read_status
            this.storeauthorizeform.permissions_coupon_edit = this.storeauthorizePermissionsData2[2].edit_status
            this.storeauthorizeform.permissions_chatbotsetting_read = this.storeauthorizePermissionsData2[3].read_status
            this.storeauthorizeform.permissions_chatbotsetting_edit = this.storeauthorizePermissionsData2[3].edit_status
            this.storeauthorizeform.permissions_chatbotmessage_read = this.storeauthorizePermissionsData2[4].read_status
            this.storeauthorizeform.permissions_chatbotmessage_edit = this.storeauthorizePermissionsData2[4].edit_status
            this.storeauthorizeform.permissions_productsetting_read = this.storeauthorizePermissionsData2[5].read_status
            this.storeauthorizeform.permissions_productsetting_edit = this.storeauthorizePermissionsData2[5].edit_status
            this.storeauthorizeform.permissions_order_read = this.storeauthorizePermissionsData2[6].read_status
            this.storeauthorizeform.permissions_order_edit = this.storeauthorizePermissionsData2[6].edit_status
            this.storeauthorizeform.permissions_payment_read = this.storeauthorizePermissionsData2[7].read_status
            this.storeauthorizeform.permissions_payment_edit = this.storeauthorizePermissionsData2[7].edit_status

            editStoreauthorizelist(this.storeauthorizeform).then((res) => {
                console.log(res);
                if (res.code == 1) {
                    this.$message({
                        type: "success",
                        message: res.msg,
                    });
                    this.dialogEditStoreauthorizeVisible = false
                    /*
                    let fdata = {
                        qyid: this.qyid,
                        storeid: this.storeauthorizeform.storeid
                    }
                    getStoreauthorizelist(fdata).then(res => {
                        if (res.code == 1) {
                            console.log(res.data);
                            this.storeauthorizeList = res.data;
                            //this.getlist()
                        } else {
                            console.log("error")
                            this.$message({
                                type: 'error',
                                message: res.msg
                            })
                        }
                    })*/

                }
                else {
                    this.$message({
                        type: "error",
                        message: res.msg,
                    });
                }
            });
        },
        addAuthorizemember() {
            console.log('aaaddd')
            console.log(this.dialogStoreauthorizeVisibleStoreid)
            this.storeauthorizeform.name='';
            this.storeauthorizeform.loginname='';
            this.storeauthorizeform.password='';
            this.storeauthorizePermissionsData1[0].status=false
            this.storeauthorizePermissionsData1[1].status=false
            this.storeauthorizePermissionsData2[0].read_status=false
            this.storeauthorizePermissionsData2[0].edit_status=false
            this.storeauthorizePermissionsData2[1].read_status=false
            this.storeauthorizePermissionsData2[1].edit_status=false
            this.storeauthorizePermissionsData2[2].read_status=false
            this.storeauthorizePermissionsData2[2].edit_status=false
            this.storeauthorizePermissionsData2[3].read_status=false
            this.storeauthorizePermissionsData2[3].edit_status=false
            this.storeauthorizePermissionsData2[4].read_status=false
            this.storeauthorizePermissionsData2[4].edit_status=false
            this.storeauthorizePermissionsData2[5].read_status=false
            this.storeauthorizePermissionsData2[5].edit_status=false
            this.storeauthorizePermissionsData2[6].read_status=false
            this.storeauthorizePermissionsData2[6].edit_status=false
            this.storeauthorizePermissionsData2[7].read_status=false
            this.storeauthorizePermissionsData2[7].edit_status=false
            this.storeauthorizePermissionsData3[0].status=false
            this.addStoreauthorizeVisibleTab = "0";
            this.dialogAddStoreauthorizeVisible = true
        },
        addStoreauthorize() {
            this.storeauthorizeform.action = "add"
            this.storeauthorizeform.permissions_storemanagement = this.storeauthorizePermissionsData1[0].status
            this.storeauthorizeform.permissions_exportcsv = this.storeauthorizePermissionsData1[1].status
            this.storeauthorizeform.permissions_managerapp_access = this.storeauthorizePermissionsData3[0].status
            this.storeauthorizeform.permissions_membership_read = this.storeauthorizePermissionsData2[0].read_status
            this.storeauthorizeform.permissions_membership_edit = this.storeauthorizePermissionsData2[0].edit_status
            this.storeauthorizeform.permissions_broadcasting_read = this.storeauthorizePermissionsData2[1].read_status
            this.storeauthorizeform.permissions_broadcasting_edit = this.storeauthorizePermissionsData2[1].edit_status
            this.storeauthorizeform.permissions_coupon_read = this.storeauthorizePermissionsData2[2].read_status
            this.storeauthorizeform.permissions_coupon_edit = this.storeauthorizePermissionsData2[2].edit_status
            this.storeauthorizeform.permissions_chatbotsetting_read = this.storeauthorizePermissionsData2[3].read_status
            this.storeauthorizeform.permissions_chatbotsetting_edit = this.storeauthorizePermissionsData2[3].edit_status
            this.storeauthorizeform.permissions_chatbotmessage_read = this.storeauthorizePermissionsData2[4].read_status
            this.storeauthorizeform.permissions_chatbotmessage_edit = this.storeauthorizePermissionsData2[4].edit_status
            this.storeauthorizeform.permissions_productsetting_read = this.storeauthorizePermissionsData2[5].read_status
            this.storeauthorizeform.permissions_productsetting_edit = this.storeauthorizePermissionsData2[5].edit_status
            this.storeauthorizeform.permissions_order_read = this.storeauthorizePermissionsData2[6].read_status
            this.storeauthorizeform.permissions_order_edit = this.storeauthorizePermissionsData2[6].edit_status
            this.storeauthorizeform.permissions_payment_read = this.storeauthorizePermissionsData2[7].read_status
            this.storeauthorizeform.permissions_payment_edit = this.storeauthorizePermissionsData2[7].edit_status
            //this.storeauthorizeform.permissionsData1 = this.permissionsData1
            //this.storeauthorizeform.permissionsData2 = this.permissionsData2
            //this.storeauthorizeform.permissionsData1.removeItem("name")
            console.log(this.storeauthorizeform)
            addStoreauthorizelist(this.storeauthorizeform).then((res) => {
                console.log(res);
                if (res.code == 1) {
                    this.$message({
                        type: "success",
                        message: res.msg,
                    });
                    this.dialogAddStoreauthorizeVisible = false
                    let fdata = {
                        qyid: this.qyid,
                        storeid: this.storeauthorizeform.storeid
                    }
                    getStoreauthorizelist(fdata).then(res => {
                        if (res.code == 1) {
                            console.log(res.data);
                            this.storeauthorizeList = res.data;
                            //this.getlist()
                        } else {
                            console.log("error")
                            this.$message({
                                type: 'error',
                                message: res.msg
                            })
                        }
                    })

                }
                else {
                    this.$message({
                        type: "error",
                        message: res.msg,
                    });
                }
            });
        },
        editAuthorizemember(id) {
            this.editStoreauthorizeVisibleTab = "0";
            this.editstoreauthorizeformid = id
            let fdata = {
                id: id,
                action: "getinfo"
            }
            getinfoStoreauthorizelist(fdata).then((res) => {
                console.log(res)
                this.storeauthorizeform.name=res.data1.name;
                this.storeauthorizeform.loginname=res.data1.login_user;
                this.storeauthorizeform.password=res.data1.login_pw;
                this.storeauthorizePermissionsData1[0].status=res.data2.store_management
                this.storeauthorizePermissionsData1[1].status=res.data2.exportcsv
                this.storeauthorizePermissionsData2[0].read_status=res.data2.membership_read
                this.storeauthorizePermissionsData2[0].edit_status=res.data2.membership_edit
                this.storeauthorizePermissionsData2[1].read_status=res.data2.broadcasting_read
                this.storeauthorizePermissionsData2[1].edit_status=res.data2.broadcasting_edit
                this.storeauthorizePermissionsData2[2].read_status=res.data2.coupon_read
                this.storeauthorizePermissionsData2[2].edit_status=res.data2.coupon_edit
                this.storeauthorizePermissionsData2[3].read_status=res.data2.chatbot_setting_read
                this.storeauthorizePermissionsData2[3].edit_status=res.data2.chatbot_setting_edit
                this.storeauthorizePermissionsData2[4].read_status=res.data2.chatbot_message_read
                this.storeauthorizePermissionsData2[4].edit_status=res.data2.chatbot_message_edit
                this.storeauthorizePermissionsData2[5].read_status=res.data2.product_setting_read
                this.storeauthorizePermissionsData2[5].edit_status=res.data2.product_setting_edit
                this.storeauthorizePermissionsData2[6].read_status=res.data2.order_read
                this.storeauthorizePermissionsData2[6].edit_status=res.data2.order_edit
                this.storeauthorizePermissionsData2[7].read_status=res.data2.payment_read
                this.storeauthorizePermissionsData2[7].edit_status=res.data2.payment_edit
                this.storeauthorizePermissionsData3[0].status=res.data2.managerapp_access


            });
            this.dialogEditStoreauthorizeVisible = true


        },
        deleteAuthorizemember(id) {
            this.$confirm(this.$t('deleteConfirm'), {
				confirmButtonText: this.$t('Sure'),
				cancelButtonText: this.$t('Cancel')
			}).then(_ => {
                let fdata = {
                    id: id,
                    action: "delete"
                }
                deleteStoreauthorizelist(fdata).then((res) => {
                    console.log(res);
                    if (res.code == 1) {
                        this.$message({
                            type: "success",
                            message: res.msg,
                        });
                        this.dialogAddStoreauthorizeVisible = false
                        let fdata = {
                            qyid: this.qyid,
                            storeid: this.storeauthorizeform.storeid
                        }
                        getStoreauthorizelist(fdata).then(res => {
                            if (res.code == 1) {
                                console.log(res.data);
                                this.storeauthorizeList = res.data;
                                //this.getlist()
                            } else {
                                console.log("error")
                                this.$message({
                                    type: 'error',
                                    message: res.msg
                                })
                            }
                        })

                    }
                    else {
                        this.$message({
                            type: "error",
                            message: res.msg,
                        });
                    }
                });

            }).catch(_ => {

            })
            
        },
        setuppickupaddress(storeid){
            this.dialogPickupAddressVisible = true;

            let fdata = {
                qyid: this.qyid,
                storeid: storeid,
                action: "viewlist"
            }
            getPickupaddresslist(fdata).then(res => {
                if (res.code == 1) {
                    console.log(res.data);
                    this.pickupaddressList = res.data;
                    //this.getlist()
                    console.log('aaaaaaaaaaaaaaaaaaaaaaaaaa')
                } else {
                    console.log("error")
                    this.$message({
                        type: 'error',
                        message: res.msg
                    })
                    console.log('bbbbbbbbbbbbbbbbbbbbbbbbbbb')
                }
            })
            
        },
        addPickupaddress() {
            this.dialogAddPickupAddressVisible = true
            this.pickupAddresssform.name = ""
            this.pickupAddressform.isDefault = ""
        },
        confirmAddPickupaddress() {
            this.pickupAddressform.action = "add";
            this.pickupAddressform.qyid = this.qyid;
            this.pickupAddressform.storeid = this.editform.storeid;
            getPickupaddresslist(this.pickupAddressform).then((res) => {
                console.log(res);
                if (res.code == 1) {
                    this.$message({
                        type: "success",
                        message: res.msg,
                    });
                    this.dialogAddPickupAddressVisible = false
                    let fdata = {
                        qyid: this.qyid,
                        storeid: this.pickupAddressform.storeid,
                        action: "viewlist"
                    }
                    getPickupaddresslist(fdata).then(res => {
                        if (res.code == 1) {
                            console.log(res.data);
                            this.pickupaddressList = res.data;
                            //this.getlist()
                        } else {
                            console.log("error")
                            this.$message({
                                type: 'error',
                                message: res.msg
                            })
                        }
                    })

                }
                else {
                    this.$message({
                        type: "error",
                        message: res.msg,
                    });
                }
            });

        },
        editPickupaddress(id) {
            this.dialogEditPickupAddressVisible = true
            this.pickupAddressform.editid = id;
            let fdata = {
                qyid: this.qyid,
                storeid: this.editform.storeid,
                id: id,
                action: "viewinfo"
            }
            getPickupaddresslist(fdata).then(res => {
                if (res.code == 1) {
                    console.log(res.data);
                    //this.storeposList = res.data;
                    //this.getlist()
                    this.pickupAddressform.location = res.data.location
                    this.pickupAddressform.time = res.data.time
                } else {
                    console.log("error")
                    this.$message({
                        type: 'error',
                        message: res.msg
                    })
                }
            })
        },
        confirmEditPickupaddress() {
            this.pickupAddressform.action = "edit";
            let fdata = {
                qyid: this.qyid,
                storeid: this.editform.storeid,
                id: this.pickupAddressform.editid,
                location: this.pickupAddressform.location,
                time: this.pickupAddressform.time,
                action: "edit"
            }
            console.log(fdata)
            getPickupaddresslist(fdata).then((res) => {
                console.log(res);
                if (res.code == 1) {
                    this.$message({
                        type: "success",
                        message: res.msg,
                    });
                    this.dialogEditPickupAddressVisible = false
                    
                    let fdata2 = {
                        qyid: this.qyid,
                        storeid: this.editform.storeid,
                        action: "viewlist"
                    }
                    getPickupaddresslist(fdata2).then(res => {
                        if (res.code == 1) {
                            console.log(res.data);
                            this.pickupaddressList = res.data;
                            //this.getlist()
                        } else {
                            console.log("error")
                            this.$message({
                                type: 'error',
                                message: res.msg
                            })
                        }
                    })

                }
                else {
                    this.$message({
                        type: "error",
                        message: res.msg,
                    });
                }
            });

        },
        deletePickupaddress(id, storeid) {
            this.$confirm(this.$t('deleteConfirm'), {
				confirmButtonText: this.$t('Sure'),
				cancelButtonText: this.$t('Cancel')
			}).then(_ => {
				let deletedata = {
					action: 'delete',
					id: id,
				}
				getPickupaddresslist(deletedata).then((res) => {
					if (res.code == 1) {
						this.$message({
							type: "success",
							message: res.msg,
						});
                        let fdata = {
                            qyid: this.qyid,
                            storeid: storeid,
                            action: "viewlist"
                        }
                        getPickupaddresslist(fdata).then(res => {
                            if (res.code == 1) {
                                console.log(res.data);
                                this.pickupaddressList = res.data;
                                //this.getlist()
                                console.log('aaaaaaaaaaaaaaaaaaaaaaaaaa')
                            } else {
                                console.log("error")
                                this.$message({
                                    type: 'error',
                                    message: res.msg
                                })
                                console.log('bbbbbbbbbbbbbbbbbbbbbbbbbbb')
                            }
                        })

					} else {
						this.$message({
							type: "error",
							message: res.msg,
						});
					}
				});
			}).catch(_ => {



			})
        },
        editstorepos(id, storeid, title) {
            this.dialogStoreposVisible = true;
            this.dialogStoreposVisibleTitle = title;
            this.dialogStoreposVisibleStoreid = storeid;
            this.storeposform.qyid = this.qyid;
            this.storeposform.storeid = storeid;
            this.storeposipform.qyid = this.qyid;
            this.storeposipform.storeid = storeid;

            this.storePOSVisibleTab = "0";
            /*
            */

            let fdata = {
                qyid: this.qyid,
                storeid: storeid,
                action: "viewlist"
            }
            getStoreposlist(fdata).then(res => {
                if (res.code == 1) {
                    console.log(res.data);
                    this.storeposList = res.data;
                    //this.getlist()
                    console.log('aaaaaaaaaaaaaaaaaaaaaaaaaa')
                } else {
                    console.log("error")
                    this.$message({
                        type: 'error',
                        message: res.msg
                    })
                    console.log('bbbbbbbbbbbbbbbbbbbbbbbbbbb')
                }
            })
            
        },
        addStorepos() {
            this.dialogAddStoreposVisible = true
            this.storeposform.name = ""
            this.storeposform.isDefault = "0"
        },
        confirmAddStorepos() {
            this.storeposform.action = "add";
            addStoreposlist(this.storeposform).then((res) => {
                console.log(res);
                if (res.code == 1) {
                    this.$message({
                        type: "success",
                        message: res.msg,
                    });
                    this.dialogAddStoreposVisible = false
                    let fdata = {
                        qyid: this.qyid,
                        storeid: this.storeposform.storeid,
                        action: "viewlist"
                    }
                    getStoreposlist(fdata).then(res => {
                        if (res.code == 1) {
                            console.log(res.data);
                            this.storeposList = res.data;
                            //this.getlist()
                        } else {
                            console.log("error")
                            this.$message({
                                type: 'error',
                                message: res.msg
                            })
                        }
                    })

                }
                else {
                    this.$message({
                        type: "error",
                        message: res.msg,
                    });
                }
            });

        },
        editStorepos(id) {
            this.dialogEditStoreposVisible = true
            this.storeposform.editid = id;
            let fdata = {
                qyid: this.qyid,
                storeid: this.storeposform.storeid,
                id: id,
                action: "viewinfo"
            }
            getStoreposlist(fdata).then(res => {
                if (res.code == 1) {
                    console.log(res.data);
                    //this.storeposList = res.data;
                    //this.getlist()
                    this.storeposform.name = res.data.name
                    this.storeposform.isDefault = res.data.isDefault
                } else {
                    console.log("error")
                    this.$message({
                        type: 'error',
                        message: res.msg
                    })
                }
            })
        },
        confirmEditStorepos() {
            this.storeposform.action = "edit";
            let fdata = {
                qyid: this.qyid,
                storeid: this.storeposform.storeid,
                id: this.storeposform.editid,
                name: this.storeposform.name,
                isDefault: this.storeposform.isDefault,
                action: "edit"
            }
            console.log(fdata)
            addStoreposlist(fdata).then((res) => {
                console.log(res);
                if (res.code == 1) {
                    this.$message({
                        type: "success",
                        message: res.msg,
                    });
                    this.dialogEditStoreposVisible = false
                    
                    let fdata2 = {
                        qyid: this.qyid,
                        storeid: this.storeposform.storeid,
                        action: "viewlist"
                    }
                    getStoreposlist(fdata2).then(res => {
                        if (res.code == 1) {
                            console.log(res.data);
                            this.storeposList = res.data;
                            //this.getlist()
                        } else {
                            console.log("error")
                            this.$message({
                                type: 'error',
                                message: res.msg
                            })
                        }
                    })

                }
                else {
                    this.$message({
                        type: "error",
                        message: res.msg,
                    });
                }
            });

        },
        deleteStorepos(id, storeid) {
            this.$confirm(this.$t('deleteConfirm'), {
				confirmButtonText: this.$t('Sure'),
				cancelButtonText: this.$t('Cancel')
			}).then(_ => {
				let deletedata = {
					action: 'delete',
					id: id,
				}
				getStoreposlist(deletedata).then((res) => {
					if (res.code == 1) {
						this.$message({
							type: "success",
							message: res.msg,
						});
                        let fdata = {
                            qyid: this.qyid,
                            storeid: storeid,
                            action: "viewlist"
                        }
                        getStoreposlist(fdata).then(res => {
                            if (res.code == 1) {
                                console.log(res.data);
                                this.storeposList = res.data;
                                //this.getlist()
                                console.log('aaaaaaaaaaaaaaaaaaaaaaaaaa')
                            } else {
                                console.log("error")
                                this.$message({
                                    type: 'error',
                                    message: res.msg
                                })
                                console.log('bbbbbbbbbbbbbbbbbbbbbbbbbbb')
                            }
                        })

					} else {
						this.$message({
							type: "error",
							message: res.msg,
						});
					}
				});
			}).catch(_ => {



			})
        },
        addStoreposipwhitelist() {
            this.dialogAddStoreposipVisible = true
            this.storeposipform.ip = ""
        },
        confirmAddStoreposip() {
            this.storeposipform.action = "add";
            storeposiplist(this.storeposipform).then((res) => {
                console.log(res);
                if (res.code == 1) {
                    this.$message({
                        type: "success",
                        message: res.msg,
                    });
                    this.dialogAddStoreposipVisible = false
                    let fdata = {
                        qyid: this.qyid,
                        storeid: this.storeposipform.storeid,
                        action: "viewlist"
                    }
                    storeposiplist(fdata).then(res => {
                        if (res.code == 1) {
                            console.log(res.data);
                            this.storeposipList = res.data;
                            this.ipenable = res.enableIP;
                            //this.getlist()
                        } else {
                            console.log("error")
                            this.$message({
                                type: 'error',
                                message: res.msg
                            })
                        }
                    })

                }
                else {
                    this.$message({
                        type: "error",
                        message: res.msg,
                    });
                }
            });

        },
        editStoreposip(id) {
            this.dialogEditStoreposipVisible = true
            this.storeposipform.editid = id;
            let fdata = {
                qyid: this.qyid,
                storeid: this.storeposipform.storeid,
                id: id,
                action: "viewinfo"
            }
            storeposiplist(fdata).then(res => {
                if (res.code == 1) {
                    console.log(res.data);
                    //this.storeposList = res.data;
                    //this.getlist()
                    this.storeposipform.ip = res.data.ip
                } else {
                    console.log("error")
                    this.$message({
                        type: 'error',
                        message: res.msg
                    })
                }
            })
        },
        confirmEditStoreposip() {
            this.storeposipform.action = "edit";
            let fdata = {
                qyid: this.qyid,
                storeid: this.storeposipform.storeid,
                id: this.storeposipform.editid,
                ip: this.storeposipform.ip,
                action: "edit"
            }
            console.log(fdata)
            storeposiplist(fdata).then((res) => {
                console.log(res);
                if (res.code == 1) {
                    this.$message({
                        type: "success",
                        message: res.msg,
                    });
                    this.dialogEditStoreposipVisible = false
                    
                    let fdata2 = {
                        qyid: this.qyid,
                        storeid: this.storeposipform.storeid,
                        action: "viewlist"
                    }
                    storeposiplist(fdata2).then(res => {
                        if (res.code == 1) {
                            console.log(res.data);
                            this.storeposipList = res.data;
                            this.ipenable = res.enableIP;
                            //this.getlist()
                        } else {
                            console.log("error")
                            this.$message({
                                type: 'error',
                                message: res.msg
                            })
                        }
                    })

                }
                else {
                    this.$message({
                        type: "error",
                        message: res.msg,
                    });
                }
            });

        },
        deleteStoreposip(id, storeid) {
            this.$confirm(this.$t('deleteConfirm'), {
				confirmButtonText: this.$t('Sure'),
				cancelButtonText: this.$t('Cancel')
			}).then(_ => {
				let deletedata = {
					action: 'delete',
					id: id,
				}
				storeposiplist(deletedata).then((res) => {
					if (res.code == 1) {
						this.$message({
							type: "success",
							message: res.msg,
						});
                        let fdata = {
                            qyid: this.qyid,
                            storeid: storeid,
                            action: "viewlist"
                        }
                        storeposiplist(fdata).then(res => {
                            if (res.code == 1) {
                                console.log(res.data);
                                this.storeposipList = res.data;
                                this.ipenable = res.enableIP;
                                //this.getlist()
                                console.log('aaaaaaaaaaaaaaaaaaaaaaaaaa')
                            } else {
                                console.log("error")
                                this.$message({
                                    type: 'error',
                                    message: res.msg
                                })
                                console.log('bbbbbbbbbbbbbbbbbbbbbbbbbbb')
                            }
                        })

					} else {
						this.$message({
							type: "error",
							message: res.msg,
						});
					}
				});
			}).catch(_ => {



			})
        },
        confirmRefundPWFPS() {
            if(this.storeposrefundpwfpsform.confirmnewpw !== this.storeposrefundpwfpsform.newpw) {
                this.$message({
                    type: "error",
                    message: "新密碼不一致"
                });
            }
            else {
                let fdata = {
                    qyid: this.qyid,
                    storeid: this.storeposform.storeid,
                    old_pw: this.storeposrefundpwfpsform.oldpw,
                    new_pw: this.storeposrefundpwfpsform.newpw,
                    action: 'setpw'
                };
                refundDBS(fdata).then((res) => {
                    if (res.code == 1) {
                        console.log(res);
                        this.dialogRefundPWFPSVisible = false
                    } else {
                        this.$message({
                            type: "error",
                            message: res.msg,
                        });
                    }
                });
            }
        },
        setupStoreposRefundPWFPS() {
            this.storeposrefundpwfpsform.oldpw = ''
            this.storeposrefundpwfpsform.newpw = ''
            this.storeposrefundpwfpsform.confirmnewpw = ''
            this.dialogRefundPWFPSVisible = true
        },
        handleStoreposTabClick() {
            switch (this.storePOSVisibleTab) {
                case "1":
                    let fdata = {
                        qyid: this.qyid,
                        storeid: this.storeposipform.storeid,
                        action: "viewlist"
                    }
                    storeposiplist(fdata).then(res => {
                        if (res.code == 1) {
                            console.log(res.data);
                            console.log(res.enableIP);
                            this.storeposipList = res.data;
                            this.ipenable = res.enableIP;
                            //this.getlist()
                        } else {
                            console.log("error")
                            this.$message({
                                type: 'error',
                                message: res.msg
                            })
                        }
                    })
                    break;

                case "2":
                    console.log("222")
                    break;

            }
        },
        changedata1(id){
            console.log(id)
        },
		//删除某个
		delitem(id) {
			this.$confirm(this.$t('deleteConfirm'), {
				confirmButtonText: this.$t('Sure'),
				cancelButtonText: this.$t('Cancel')
			}).then(_ => {

				console.log('del..');
				var user = JSON.parse(window.localStorage.getItem("userinfo"));
				let deletedata = {
					action: 'delete',
					id: id,
					qyid: user.id
				}
				addStore(deletedata).then((res) => {
					if (res.code == 1) {
						this.$message({
							type: "success",
							message: res.msg,
						});
						this.dialogVisible = false
						this.gettemplist()
					} else {
						this.$message({
							type: "error",
							message: res.msg,
						});
					}
				});
			}).catch(_ => {



			})


		},
		// 我的範本列表
		gettemplist() {
			console.log('go taocan');
			var user = JSON.parse(window.localStorage.getItem('userinfo'))

			/*
			let fdata = {
				sjk: 'messenger_storelist',
				action: 'list',
				qyid: user.id
			}
			tongyong(fdata).then(res => {
				if (res.code == 1) {
					console.log(fdata);
					console.log(res);
					this.tableData = res.data
				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})*/
			let fdata = {
				qyid: this.qyid,
                storeid: this.storeid
			};
			getStore(fdata).then((res) => {
				if (res.code == 1) {
					console.log(res);
					this.tableData = res.data;
				} else {
					this.$message({
						type: "error",
						message: res.msg,
					});
				}
			});
		},


		//pagelist 
		getpagelist() {
			console.log('go taocan');
			var user = JSON.parse(window.localStorage.getItem('userinfo'))

			let fdata = {
				sjk: 'messenger_pagelist',
				action: 'list',

				qyid: user.id
			}
			tongyong(fdata).then(res => {
				if (res.code == 1) {
					console.log(res);
					this.pagelist = res.data
				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})
		},

		//pagelist 
		gethuodonglist() {
			console.log('go taocan');
			var user = JSON.parse(window.localStorage.getItem('userinfo'))

			let fdata = {
				sjk: 'messenger_huodong_yhq',
				action: 'list',

				qyid: user.id
			}
			tongyong(fdata).then(res => {
				if (res.code == 1) {
					console.log(res);
					this.huodonglist = res.data
				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})
		},


		ewm(str, pageid) {
			var user = JSON.parse(window.localStorage.getItem('userinfo'))
			console.log(user);
			this.dialogVisible_ewm = true
			this.qyid = user.id
			let fdata = {
				do: 'ewm',
				qyid: this.qyid,
				pageid: pageid,
				ref: str,
				type: 'link',


			}
			console.log('go ewm', fdata);


			funk(fdata).then(res => {
				if (res.code == 1) {
					console.log(res);
					this.ewmdata = res
					console.log(this.ewmdata)
					// const html ='<div style="text-algin:center;">H5:<a target="_blank"  href="'+res.url+'">link</a> <br><img src='+res.path+' /> <br>Whatsapp:<a target="_blank"  href="'+res.wurl+'">link</a> <button class="tag-read" :data-clipboard-text="aaa" @click="copy">复制</button></el-button><br> <img src='+res.whatsapp+' /> <br></div>' 
					// this.$alert(html, '預約排隊二維碼', {
					//           dangerouslyUseHTMLString: true
					//         });


				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})
		},
		//上传--

		// 删除
		handleRemove(file) {
			let uploadFiles = this.$refs.elUpload.uploadFiles;
			uploadFiles.forEach((value, index) => {
				if (value.uid === file.uid) {
					uploadFiles.splice(index, 1)
					this.fileList.splice(index, 1)
				}
			})
		},
		// 大图预览
		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url;
			this.showViewer = true;
		},
		// 下载圖片
		handleDownload(file) {
			let a = document.createElement('a');
			a.download = file.name;
			a.href = (file.url);
			a.click();
		},
		// 重写上传
		uploadSectionFile(params) {
			const file = params.file,
				fileType = file.type,
				isImage = fileType.indexOf('image') !== -1,
				isLt2M = file.size / 1024 / 1024 < 2;
			// 这里常规检验，看项目需求而定
			if (!isImage) {
				this.$message.error('只能上传圖片格式png、jpg、gif!');
				return;
			}
			if (!isLt2M) {
				this.$message.error('只能上传圖片大小小于2M');
				return;
			}
			// 根据后台需求数据格式
			const form1 = new FormData();
			// 文件对象
			form1.append('file', file);
			// 本例子主要要在请求时新增特定属性，所以要用自己方法覆盖默认的action
			// form.append("clientType", 'xxx');
			// 项目封装的请求方法，下面做简单介绍


			imageUpload(form1).then(res => {
				//自行处理各种情况
				console.log('res', res)
				this.form.image = res
			}).catch(() => {
				// xxx
			});
		},
		// 关闭
		closeViewer() {
			this.showViewer = false;
		},
		sortChange({ prop, order }) {
			this.tableData.sort(this.compare(prop, order));
		},
		compare(propertyName, sort) {
			return function (obj1, obj2) {
				var value1 = obj1[propertyName]
				var value2 = obj2[propertyName]
				if (typeof value1 === 'string' && typeof value2 === 'string') {
					const res = value1.localeCompare(value2, 'zh')
					return sort === 'ascending' ? res : -res
				} else {
					if (value1 <= value2) {
						return sort === 'ascending' ? -1 : 1
					} else if (value1 > value2) {
						return sort === 'ascending' ? 1 : -1
					}
				}
			}
		}




	}
}
</script>
<style lang="scss" scoped>
.el-pagination__total {
	display: inline-block;
	font-size: 13px;
	min-width: 35.5px;
	height: 28px;
	line-height: 28px;
	vertical-align: top;
	box-sizing: border-box;
}

.pagination {
	width: 100%;
	margin: 30px auto;
}

::v-deep .el-select {
	width: 100%;

}
</style>
